import { useMyKnowledgeBasesQuery } from '../../graphql/schema';
import KnowledgeBasesSelect from '../form/KnowledgeBaseSelect';

interface Props {
  value?: string[] | null;
  onChange?: (value: string[]) => void;
  rounded?: boolean;
}

interface Option {
  label: string;
  value: string;
}

const MyKnowledgeBasesSelect = ({ value, onChange, rounded }: Props) => {
  const { data, loading } = useMyKnowledgeBasesQuery();

  const options: Option[] =
    data?.myKnowledgeBases.map((item) => {
      return {
        label: item.name,
        value: item.id,
      };
    }) || [];

  if (data?.myKnowledgeBases.length === 0) return null;

  return (
    <KnowledgeBasesSelect
      rounded={rounded}
      options={options}
      loading={loading}
      value={value}
      onChange={onChange}
    />
  );
};

export default MyKnowledgeBasesSelect;
